import { useContext } from "react";

import { CheckoutConfigurationContext } from "@commerce/providers";
import type { CheckoutConfiguration } from "@commerce/types/CheckoutConfiguration.types";

export const useCheckoutConfiguration = (): CheckoutConfiguration => {
  return useContext(CheckoutConfigurationContext);
};
